<main class="container" *ngIf="calendarData">
    <div class="top-section">
        <div class="calendar-header">
            <div class="calendar-title">
                <finder-title [title]="labels.title"></finder-title>
                <span class="current-date">{{fullDateString}}</span>
            </div>
            <finder-switch-button
                *ngIf="calendarData.switchButton"
                (viewChanged)="onViewChanged($event)"
                [selected]="viewType"
                [links]="switchButtonLinks">
            </finder-switch-button>
        </div>
        <div class="calendar-date-picker">
            <ng-container
                *ngTemplateOutlet="datePicker; context: {$implicit: datePickerText}">
            </ng-container>
            <div class="sponsor-link-container">
                <finder-anchor
                    class="link"
                    *ngIf="links?.annualPass"
                    [href]="links.annualPass">
                    {{labels.links.annualPass}}
                </finder-anchor>
                <div class="calendar-sponsorship"  *ngIf="sponsorShipLogoUrl">
                    <span *ngIf="sponsorshipCopy[0]" [innerHtml]="sponsorshipCopy[0] | safeHtml"></span>
                    <img class="sponsorship-logo" [src]="sponsorShipLogoUrl" />
                    <span *ngIf="sponsorshipCopy[1]" [innerHtml]="sponsorshipCopy[1] | safeHtml"></span>
                </div>
            </div>
        </div>
        <div class="calendar-filters" (finderIntersection)="showStickyBar(!$event.isIntersecting)">
            <finder-calendar-filters class="filter"
                [filters]="calendarData.filters"
                [showFilters]="calendarData.showFilters">
            </finder-calendar-filters>
        </div>
    </div>
    <div class="middle-section">
        <div class="date-range" *ngIf="fiveDay">
            <span class="date" *ngFor="let date of dateRange.formattedDates">{{date.day}}</span>
        </div>
    </div>
    <div *ngIf="disclaimer" class="disclaimer-section" [ngClass]="{'five-day' : fiveDay}">
        <finder-breadcrumb
            class="disclaimer"
            [links]="disclaimer.links"
            [breadcrumb]="disclaimer.breadcrumbTemplate"
            [hasFullContentReader]="true">
        </finder-breadcrumb>
    </div>
    <div class="calendar-locations" [ngClass]="{'five-day' : fiveDay}">
        <div class="default-view" *ngIf="defaultView">
            <span class="text">{{labels.defaultViewText}}</span>
        </div>
        <router-outlet></router-outlet>
    </div>
    <finder-sticky-bar *ngIf="stickyBar"
        [fiveDay]="fiveDay"
        [dateRange]="dateRange"
        [shortDateString]="shortDateString"
        (mobileFilters)="openMobileFilters()"
        (datePickerModal)="openDatePickerModal()"
        [labels]="labels">
        <ng-container
            *ngTemplateOutlet="datePicker; context: {$implicit: fiveDay ? datePickerText : fullDateString}">
        </ng-container>
    </finder-sticky-bar>
</main>

<ng-template #datePicker let-text>
    <finder-date-picker-wrapper
        [(date)]="selectedDate"
        (dateChanged)="onDateChanged($event)"
        [dateText]="text"
        [highlightedDates]="fiveDay ? dateRange.dates : []"
        [hoverConfig]="calendarData.datePicker?.hover"
        [labels]="labels"
        [maxDays]="calendarData.datePicker?.maxCalendarDays">
    </finder-date-picker-wrapper>
</ng-template>
